import { Component, OnInit, Input, Output, EventEmitter, AfterContentInit, ContentChildren, QueryList, OnChanges, SimpleChanges } from '@angular/core';
import { IDataGridDefinition, IDataGridSource, IDataGridEvent, IDataGridButtonEvent } from '../../../interfaces/data-grid.interface';
import { SiuTemplateDirective } from '../../../directives/siu-template.directive';

@Component({
  selector: 'siu-data-grid-old',
  templateUrl: './data-grid.component.html',
  styleUrls: [ './data-grid.component.scss' ]
})
export class DataGridComponent implements OnInit, AfterContentInit, OnChanges {

  @Input() emptyRowsMsg: string = 'No se encontraron resultados';
  @Input() loading: boolean;
  @Input() definition: IDataGridDefinition;
  @Input() source: IDataGridSource<any>;
  @Input() pageSizeOptions = [ 10, 25, 50, 100 ];
  @Output('on-load-data') onLoadDataEvent: EventEmitter<IDataGridEvent> = new EventEmitter();
  @Output('on-click-button') onClickButtonEvent: EventEmitter<IDataGridButtonEvent> = new EventEmitter();
  @Input() noElevation: boolean = false;
  @ContentChildren(SiuTemplateDirective) templates: QueryList<SiuTemplateDirective>;
  @Input() serverError?: any = null;


  displayedColumns: string[];
  customTemplates: any = {};
  anyEditable: boolean = false;

  /**
   * objeto que alamacena los datos para grilla editable por file
   * ejem: editWorkData[0]: alamacena los datos de edición para la fila 0
   */
  editWorkData: any = {};

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.definition && changes.definition.currentValue) {
      this.displayedColumns = this.definition.columns.filter(x => x.hidden !== true).map(x => x.field);
      //this.anyEditable = this.definition.columns.filter(x => x.editable).length > 0;
    }
  }

  ngAfterContentInit(): void {
    const customColumns = this.definition.columns.filter(x => x.template);

    if (customColumns.length > 0) {
      customColumns.forEach(x => {
        const matches = this.templates.filter(temp => temp.getType() == x.field);
        if (matches.length > 0) {
          this.customTemplates[ x.field ] = matches[ 0 ].template;
        }
      });
    }
  }

  handleChangePage = (page) => {
    this.resetEditWorkData();
    this.onLoadDataEvent.emit({
      page,
      pageSize: this.source.pageSize,
      orderBy: this.source.orderBy,
      orderDir: this.source.orderDir,
      skip: this.calcSkipByPage(page, this.source.pageSize)
    });
  }

  handleSort = (event) => {
    this.resetEditWorkData();
    this.onLoadDataEvent.emit({
      page: this.source.page,
      pageSize: this.source.pageSize,
      orderBy: event.active,
      orderDir: event.direction,
      skip: this.calcSkipByPage(this.source.page, this.source.pageSize)
    });
  }

  handleChangePageSize = (pageSize) => {
    const page = 1;
    this.resetEditWorkData();
    this.onLoadDataEvent.emit({
      page: page,
      pageSize: pageSize,
      orderBy: this.source.orderBy,
      orderDir: this.source.orderDir,
      skip: this.calcSkipByPage(page, pageSize)
    });
  }

  handleClickButton = (event, item, index) => {
    this.onClickButtonEvent.emit({ item, action: event.action, index });
  }

  private calcSkipByPage = (page: number, pageSize: number): number => {
    return (page - 1) * pageSize;
  }

  private resetEditWorkData = () => {
    this.editWorkData = {};
  }

  handleClickEdit = (rowIndex: number) => {
    const data = this.source.items[ rowIndex ];
    this.editWorkData[ rowIndex ] = { $$edit: true, data: JSON.parse(JSON.stringify(data)) };
    console.log(this.editWorkData[ rowIndex ]);
  }

  handleClickSave = (rowIndex: number) => {

  }

  handleClickDiscard = (rowIndex: number) => {
    this.editWorkData[ rowIndex ] = undefined;
  }

  // get fullSource (){

  //   return [{}, {}].concat(this.source.items);
  // }
}
